<template>
  <div class="home-box">
    <m-header></m-header>
    <!-- <m-Total></m-Total> -->
    <div class="banner">
      <el-carousel :interval="5000" arrow="always" height="600px">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <div :style="{ textAlign: 'center' }">
            <el-image style="height: 600px" :src="linkAllImgUrl(item.url)" fit="scale-down"></el-image>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="title">
        <div class="c">
          <h1>{{ title }}</h1>
          <template v-if="userInfo.aId != creatorId">
            <div v-if="mxType == 1" class="vipFreeText">VIP会员免费下</div>

            <div v-if="priceType == 0 && price !== 0" class="price">
              {{ price ? `积分${price}` : '' }}
            </div>
            <div v-if="priceType == 2" class="price">
              {{ price ? `积分${price}` : '' }}
            </div>
            <div v-else-if="priceType == 1 && price !== 0" class="price">
              <span class="textprice">原价</span>
              <div class="mxtypetext" v-if="memberState == 0">
                <span class="pricenum_1">{{ price ? `搜币${price}` : '' }}</span>
                <span class="dispricetxt">会员折扣价</span>
                <span class="pricenum">搜币{{ coinsCount }}</span>
              </div>
              <div class="typetext" v-else>
                <span class="pricenum">{{ price ? `搜币${price}` : '' }}</span>
                <span class="textrebates">开通会员立享折扣</span>
              </div>

            </div>
            <div class="price-type" v-else-if="priceType == 0 && price == 0">
              免费
            </div>
            <div class="price-type" v-else-if="priceType == 3">
              免费
            </div>
            <div class="btn" @click="addCart">
              加入购物车
            </div>
          </template>
          <template v-else>
            <div v-if="mxType === 1" class="vipFreeText">VIP会员免费下</div>
            <div v-if="priceType == 0 && price !== 0" class="price">
              {{ price ? `积分${price}` : '' }}
            </div>
            <div v-if="priceType == 2" class="price">
              {{ price ? `积分${price}` : '' }}
            </div>
            <div v-else-if="priceType == 1 && price !== 0" class="price">
              <span class="textprice">原价</span>
              <div class="mxtypetext" v-if="memberState == 0">
                <span class="pricenum_1">{{ price ? `搜币${price}` : '' }}</span>
                <span class="dispricetxt">会员折扣价</span>
                <span class="pricenum">搜币{{ coinsCount }}</span>
              </div>
              <div class="typetext" v-else>
                <span class="pricenum">{{ price ? `搜币${price}` : '' }}</span>
                <span class="textrebates">开通会员立享折扣</span>
              </div>
            </div>
            <div class="price-type" v-else-if="priceType == 0 && price == 0">
              免费
            </div>
            <div class="price-type" v-else-if="priceType == 3">
              免费
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="__d">
      <div class="___d">
        <div class="content">
          <!-- 介绍 -->
          <el-card class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }">
            <div slot="header" class="clearfix">
              <span>介绍</span>
            </div>
            <div>

              <div ref="recruitContent" class="editor __remark" v-html="remark"></div>
            </div>
          </el-card>
          <!-- 官方提示 -->
          <el-card class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }">
            <div class="officialText">官方提示：</div>
            <div class="descContent">
              <div>请仔细阅读描述格式 版本 渲染器和插件。obj fbx等通用格式不会兼容所有软件，购买前先咨询。</div>
              <div>格式转换出错 软件不兼容问题不在售后范围内。</div>
              <div>使用非描述中的格式 版本以及软件环境打开文件可能会有不兼容的问题。此情况不在售后范围内，请按需购买。</div>
              <div>模型为三维数字模型，虚拟物品，非实体模型，与现实环境中的真实物体有差异</div>
            </div>
            <div class="copyrightText">版权说明：</div>
            <div class="descContent_1">
              <div> 在本站下载的素材，著作权归原作者所有。</div>
              <div>如需获得商业授权，购买前请咨询作者或者联系客服。未经书面授权或签订书面合同，不得以任何形式发行、发布、传播、复制、出租、转售、汇编该素材。</div>
              <div> 您所购买并下载的素材，系由发布人进行上传并出售，您认为该内容侵犯您合法权益的，请点击 <span
                  style="color: #f00;font-size: 14px;text-decoration: underline;cursor: pointer;"
                  @click="createWordOrder">举报</span> 反馈。
              </div>
              <div class="txt">1、如该资源发布者无特别说明，模型结构、精度及细节等，以预览图、线框图展示为准。</div>
              <div class="txt">2、预览图中未展示部分则没有设计，如有任何疑问请在购买前联系客服咨询。</div>
              <div class="txt"> 3、如有obj、fbx等通用格式，其导入三维软件或引擎中均无法直接达到原始文件中展示的渲染效果，需要手动进行二次调整。详情请仔细阅读<span
                  style="color: #f00;font-size: 14px; text-decoration: underline;cursor: pointer;"
                  @click="openHelpInstruct">《格式说明帮助文档》</span> 。</div>
            </div>

          </el-card>

          <!-- 活动 -->
          <el-card class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }" v-if="labelList.length">
            <div slot="header" class="clearfix" :style="{ fontSize: '14px' }">
              <span>活动</span>
            </div>
            <div>
              <el-tag @click="goSearch('label', item.id, item.name)"
                :style="{ marginRight: '10px', marginBottom: '5px', cursor: 'pointer' }" type="success" size="medium"
                v-for="(item, index) in labelList" :key="index">{{ item.name }}</el-tag>
            </div>
          </el-card>

          <!-- 评论 -->
          <el-card v-if="commentFlag" class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }">
            <div slot="header" class="clearfix">
              <span>评论</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="handleAddContent">添加评论</el-button>
            </div>
            <div>
              <div class="comment_inner" v-for="(item, index) in list" :key="index">
                <span v-if="isAuthor() === creatorId" class="authorBtn" @click="authorBtnClick(item)">回复</span>
                <div class="__r">
                  <pre>{{ item.remContent }}</pre>
                </div>
                <div v-if="item.authReplyContent" class="__rcommet">作者回复:
                  <pre>{{ item.authReplyContent }}</pre>
                </div>
                <div class="c_time">{{ item.createdTime }}</div>
              </div>
            </div>
          </el-card>
        </div>

        <div class="___r">
          <el-card class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }">
            <div slot="header" class="clearfix" :style="{ fontSize: '14px' }">
              <span>版权</span>
              <a href="#" style="color: #f00;font-size: 14px; margin-left: 270px; text-decoration: underline;"
                @click="createWordOrder">举报</a>
            </div>
            <div style="position: relative;">
              <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" type="success" size="medium"
                v-for="(item, index) in copyrightText" :key="index">{{ item }}</el-tag>
              <a href="#"
                style="color: #f00;font-size: 14px; text-decoration: underline;position: absolute;top: 15px;right: 0px;"
                @click="createWordOrder">模型反馈</a>
            </div>
          </el-card>

          <el-card class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }" v-if="classifyList.length">
            <div slot="header" class="clearfix" :style="{ fontSize: '14px' }">
              <span>格式</span>
            </div>
            <div>
              <div :style="{ borderBottom: '1px solid #f5f5f5', marginBottom: '5px', paddingBottom: '7px' }"><el-tag
                  @click="goSearch('categoryId', item.id)"
                  :style="{ marginRight: '10px', marginBottom: '5px', cursor: 'pointer' }" size="medium"
                  v-for="(item, index) in classifyList" :key="index">{{ item.name }}</el-tag></div>
              <div :style="{ borderBottom: '1px solid #f5f5f5', marginBottom: '5px', paddingBottom: '7px' }"><el-tag
                  :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium"
                  v-for="(item, index) in industryList" :key="index">{{ item.name }}</el-tag></div>
              <div :style="{ borderBottom: '1px solid #f5f5f5', marginBottom: '5px', paddingBottom: '7px' }"><el-tag
                  :style="{ marginRight: '10px', marginBottom: '5px' }" type="success" size="medium"
                  v-for="(item, index) in softText" :key="index">{{ item }}</el-tag></div>
              <div><el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium"
                  v-for="(item, index) in renderText" :key="index">{{ item }}</el-tag></div>
            </div>
          </el-card>
          <el-card class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }" v-if="industryList.length">
            <div slot="header" class="clearfix" :style="{ fontSize: '14px' }">
              <span>详细信息</span>
            </div>
            <div>
              <div v-if="isAuth"
                :style="{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #f5f5f5', marginBottom: '5px', paddingBottom: '7px' }">
                <img style="width: 40px; height: 40px; margin-right: 10px;" src="~@/assets/畅快.png">
                <div style="width: 280px;">
                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium">畅快用</el-tag>
                </div>
              </div>
              <div v-if="pointNum || surfaceNum"
                :style="{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #f5f5f5', marginBottom: '5px', paddingBottom: '7px' }">
                <img style="width: 40px; height: 40px; margin-right: 10px;" src="~@/assets/面数.png">
                <div style="width: 280px;">
                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium">{{ surfaceNum }}面</el-tag>
                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium">{{ pointNum }}点</el-tag>
                </div>
              </div>
              <div v-if="threeLineText && threeLineText.length"
                :style="{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #f5f5f5', marginBottom: '5px', paddingBottom: '7px' }">
                <img style="width: 40px; height: 40px; margin-right: 10px;" src="~@/assets/纹理.png">
                <div style="width: 280px;">
                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium"
                    v-for="(item, index) in threeLineText" :key="index">{{ item }}</el-tag>
                </div>
              </div>
              <div v-if="fourLineText && fourLineText.length" :style="{ display: 'flex', alignItems: 'center', }">
                <img style="width: 40px; height: 40px; margin-right: 10px;" src="~@/assets/绑定.png">
                <div style="width: 280px;">
                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" type="success" size="medium"
                    v-for="(item, index) in fourLineText" :key="index">{{ item }}</el-tag>
                </div>
              </div>

            </div>
          </el-card>

          <el-card class="box-card" :style="{ marginRight: '10px', marginBottom: '5px' }" v-if="softText.length">
            <div slot="header" class="clearfix" :style="{ fontSize: '14px' }">
              <span>作者</span>
            </div>
            <div class="__anthor">
              <div style="display: flex; width: 50%;">
                <div class="avatar" @click="goAvatarSearch">
                  <div class="a"
                    :style="{ backgroundImage: `url(${linkAllImgUrl(creatorAvatar)})`, backgroundSize: `50px 50px` }">
                  </div>
                </div>
                <div :style="{ paddingLeft: '20px' }">
                  <div @click="goAvatarSearch"
                    :style="{ height: '20px', lineHeight: creatorSexText ? '20px' : '50px', color: 'rgb(110, 198, 236)', fontSize: '12px', cursor: 'pointer' }">
                    <span>{{ creatorName }}</span>
                  </div>
                  <div :style="{ height: '25px', lineHeight: '25px', color: '#808080', fontSize: '12px' }"
                    v-if="creatorSexText"><span>性别:{{ creatorSexText }}</span></div>
                </div>
              </div>

              <div style="display: flex; width: 50%;">
                <div class="avatar" style="width: 50px;">
                  <img style="width: 50px; height: 50px;" src="~@/assets/资产png.png">
                </div>
                <div :style="{ paddingLeft: '15px' }">

                  <div :style="{ height: '25px', lineHeight: '25px', color: '#808080', fontSize: '12px' }">拥有资产</div>
                  <div :style="{ height: '25px', lineHeight: '25px', color: '#808080', fontSize: '12px' }">{{ publishNum
                  }}
                  </div>
                </div>
              </div>

            </div>
          </el-card>

        </div>

      </div>
    </div>

    <el-dialog :title="isAuthorReply ? '回复' : '评论'" :visible.sync="visible" width="600px">
      <div>
        <el-form ref="replyForm" :model="replyForm" label-width="80px" :rules="replyRules">
          <el-form-item :label="isAuthorReply ? '回复内容' : '评论内容'" prop="replyContent">
            <el-input type="textarea" v-model="replyForm.replyContent"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="onReplySubmit">{{ isAuthorReply ? '回复' : '评论' }}</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

    </el-dialog>

    <el-dialog title="提交服务单" :visible.sync="dialogVisible" width="600px">
      <div>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="类型" prop="woType">
            <el-select v-model="form.woType" placeholder="请选择工单类型">
              <el-option v-for="(item, index) in workTypes" :key="index" :label="item.woTypeName"
                :value="item.woTypeCode"></el-option>

            </el-select>
          </el-form-item>

          <el-form-item label="标题" prop="woTitle">
            <el-input v-model="form.woTitle"></el-input>
          </el-form-item>

          <el-form-item label="内容" prop="woDesc">
            <el-input type="textarea" v-model="form.woDesc"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="onSubmit">立即创建</el-button>
            <el-button size="small" @click="dialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="格式说明帮助文档" :visible.sync="isHelpInstructDia" width="800px">
      <div class="helpInstructDia">
        <div>对常见格式进行简单说明，购买前请详细阅读，由格式文件产生的问题会对买卖双方进行协商，为保证您的权益，购买前可与客服沟通。</div>
        <div>1、FBX：</div>
        <div>
          FBX主流通用格式之一，包含多边形模型、贴图材质信息、蒙皮动画、点缓存动画、骨骼等信息，可导入多数主流软件中，如：3Dmax、Maya、C4D、Blender、Houdini、UE、Unity等，请注意，FBX文件导入软件中还需自行调整坏境、材质效果等。
        </div>
        <div>2、OBJ：</div>
        <div>OBJ包含多边形网格，不包含动画信息，同FBX主流通用格式之一，也可导入多数主流软件中，请注意，OBJ导入软件中也需自行调整坏境、材质效果等。</div>
        <div>3、.Max：</div>
        <div>Autodesk 3Dmax 主要软件格式，可建模、渲染、特效等制作，广泛用于游戏建模、建筑动画、影视等，注意软件高版本兼容低版本，低版本无法打开高版本，购买时请注意版本信息。</div>
        <div>4、.c4d：</div>
        <div>MAXON CINEMA 4D主流软件格式，可建模、渲染、特效等制作，广泛用于广告、影视等，注意版本兼容问题，不同版本会产生未知问题。</div>
        <div>5、.mb</div>
        <div>Autodesk Maya 主要软件格式，可建模，渲染，特效等制作，广泛用于影视等， 注意软件高版本兼容低版本，低版本无法打开高版本，购买时请注意版本信息。</div>
        <div>5、.blender：</div>
        <div>Blender主要软件格式，可建模，渲染，特效，后期制作等，广泛用于影视，广告等，注意版本兼容问题，不同版本会产生未知问题。</div>
        <div>6、代理文件</div>
        <div>Vray代理文件在使用过程中要指定好路径，方可正确显示。</div>
        <div>7、.uproject</div>
        <div>UE主要软件格式，广泛用于游戏、影视等，UE整体文件较大，购买请注意版本兼容问题。</div>
        <div>8、骨骼文件</div>
        <div>骨骼文件等文件导入时要注意单位设置，单位错误会导致骨骼错乱，如模型没标明，购买前可联系客服咨询模型信息。</div>
        <div>9、UDIM贴图</div>
        <div>UDIM贴图在不同软件中的使用方法不同，使用时请注意贴图设置。</div>
        <div style="margin-bottom: 20px;">如若有其他问题可联系客服咨询。</div>
        <button class="sureBtn" @click="sure">知道了</button>
      </div>
    </el-dialog>
    <div :style="{ margin: '20px auto', width: '1500px' }" v-if="recommended">
      <el-divider content-position="center" style="font-size: 90px;">相关推荐</el-divider>

      <search-component :isDetail="true" :detailCategory="classifyIdList" :detailAssId="assetsId"
        v-if="classifyIdList.length != 0">
      </search-component>
    </div>
    <m-footer></m-footer>
  </div>
</template>

<script>
import { mapListApi } from "@/api/resource";
import { getDetail, addCart, getCart, getLabelById, classIdApi, industryIdApi, createContent, queryCommentList, AuthorComment, getCommentConfig, queryAllWorkType, createWork, queryWorkList } from '@/api/extra'
import { mapGetters, mapMutations } from "vuex";
import { decode } from 'js-base64';
import commonMixin from "@/mixins/commonMixin";
import SearchComponent from "./search.vue";
export default {
  mixins: [commonMixin],
  components: {
    SearchComponent
  },
  data () {
    return {
      recommended: true,
      imgList: [],
      visible: false,
      replyForm: {
        replyContent: ''
      },
      creatorId: null,
      replyRules: {
        replyContent: [
          { required: true, message: '请填写内容', trigger: 'blur' }
        ]
      },
      pageObj: {
        pageNum: 1,
        pageSize: 10
      },
      form: { // 提交工单
        woTitle: '',
        woType: '',
        woDesc: '',
      },
      isAuthorReply: false,
      activeNames: ['1', '2', '3', '4', '5', '6', '7'],
      title: '',
      priceType: 0,
      price: '',
      isAuth: 0,
      pointNum: 0,
      surfaceNum: 0,
      labelList: [],
      softList: [],
      renderList: [],
      copyrightList: [],
      classifyIdList: [],
      classifyList: [],
      includeList: [],
      includeIdList: [],
      industryList: [],
      softwareIdList: [],
      rendererIdList: [],
      copyright: '',
      remark: '',
      list: [],
      creatorAvatar: '',
      creatorName: '',
      publishNum: '',
      commentFlag: false, //评论是否展示开关
      userInfo: [],
      creatorId: '',
      assetsId: '',
      mxType: null,
      memberState: null, // 0是会员 / 1 null 不是会员
      byDiscount: null,
      hjDiscount: null,
      zsDiscount: null,
      memberType: null, // 会员类型
      dialogVisible: false,
      rules: { // 提交工单表单验证
        woTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        woType: [
          { required: true, message: '请选择工单类型', trigger: 'change' },
        ],
        woDesc: [{ required: true, message: '请填写内容', trigger: 'blur' }],
      },
      workTypes: [],
      isHelpInstructDia: false
    };
  },
  computed: {
    ...mapGetters(["GET_USER_INFO"]),
    softText () {
      let strArr = [];
      let arr = this.softList.filter(item => this.softwareIdList.includes(item.id));
      arr.forEach(item => {
        strArr.push(item.name)
      })
      return strArr
    },

    cludeText () {
      let strArr = [];
      let arr = this.includeList.filter(item => this.includeIdList.includes(item.id));
      arr.forEach(item => {
        strArr.push(item.name)
      })
      return strArr
    },

    threeLineText () {
      let strArr = [];
      let arr = this.includeList.filter(item => [104, 106].includes(item.id) && this.includeIdList.includes(item.id));
      arr.forEach(item => {
        strArr.push(item.name)
      })
      return strArr
    },

    fourLineText () {
      let strArr = [];
      let arr = this.includeList.filter(item => ![104, 106].includes(item.id) && this.includeIdList.includes(item.id));
      arr.forEach(item => {
        strArr.push(item.name)
      })
      return strArr
    },

    renderText () {
      let strArr = [];
      let arr = this.renderList.filter(item => this.rendererIdList.includes(item.id));
      arr.forEach(item => {
        strArr.push(item.name)
      })

      return strArr
    },
    copyrightText () {
      let strArr = [];
      let arr = this.copyrightList.filter(item => this.copyright == item.id);
      arr.forEach(item => {
        strArr.push(item.name)
      })
      return strArr
    },
    creatorSexText () {
      if (this.creatorSex === 1) {
        return '男'
      }
      if (this.creatorSex === 0) {
        return '女'
      }
      return null
    },
    coinsCount () {
      if (this.memberType === 1) {
        return this.price * (this.byDiscount / 100)
      } else if (this.memberType === 2) {
        return this.price * (this.hjDiscount / 100)
      } else if (this.memberType === 3) {
        return this.price * (this.zsDiscount / 100)
      }
    }


  },
  created () {
    this.fetchData();
    queryAllWorkType().then((res) => {
      if (res && res.code === 200) {
        this.workTypes = res.data;
      }
    });

    this.memberState = localStorage.getItem('memberState')


    let arr = this.GET_USER_INFO.token.split('.')
    if (arr.length < 2) {
      this.userInfo = { aId: '-1' };
    } else {
      this.userInfo = JSON.parse(decode(arr[1]))
    }
    this.getDetail()
    this.getSoftList()
    this.getRenderList()
    this.getCopyrightList()
    this.isAuthor()
    this.getIncludeList()
    this.getComment();
  },

  // 路由钩子
  beforeRouteLeave (to, from, next) {
    if (to.path.search("search")) {
      // 返回判定標誌
      localStorage.setItem("detailGoBackSearch", true);
    } else {
      // 返回判定標誌
      localStorage.setItem("detailGoBackSearch", false);
    }
    next();
  },

  mounted () {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }

  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false);
  },
  watch: {
    GET_USER_INFO: {
      immediate: true,
      handler: function (val) {
        if (!val.token) {
          return
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_CART_VISIBLE: "SET_CART_VISIBLE"
    }),
    sure () {
      this.isHelpInstructDia = false
    },
    openHelpInstruct () {
      this.isHelpInstructDia = true;
    },
    createWordOrder () {
      this.dialogVisible = true;
    },
    goSearch (name, id, labelName) {
      if (labelName) {
        this.$router.push(`/search?${name}=${+id}&labelName=${labelName}`)
        return
      }
      this.$router.push(`/search?${name}=${+id}`)
    },
    goAvatarSearch () {
      this.$router.push(`/search?creatorId=${this.creatorId}&creatorName=${this.creatorName}`)
    },
    isAuthor () {
      if (!this.GET_USER_INFO.token) {
        return false
      } else {
        let arr = this.GET_USER_INFO.token.split('.')
        let userInfo = JSON.parse(decode(arr[1]))
        return userInfo.aId
      }
    },
    getComment () {
      getCommentConfig().then(res => {
        if (res && res.code === 200) {
          // 1就是开  0是关
          this.commentFlag = res.data?.status == 1;
          if (res.data?.status == 1) {
            this.queryCommentList();
          }
        }
      })
    },
    queryCommentList () {
      const { query: { id } } = this.$route
      queryCommentList({
        remSourceId: id,
        ...this.pageObj
      }).then(res => {
        if (res && res.code === 200) {
          this.list = res.data.list
        }
      })
    },
    handleChange () { },
    onReplySubmit () {
      const { query: { id } } = this.$route
      if (!this.isAuthorReply) {
        this.$refs['replyForm'].validate(valid => {
          if (valid) {
            createContent({
              remType: 1,
              remSourceId: +id,
              remSourceTitle: this.title,
              remContent: this.replyForm.replyContent
            }).then(res => {
              if (res && res.code === 200) {
                this.visible = false
                this.replyForm.replyContent = ''
                this.$message({
                  type: 'success',
                  message: '评论成功，请等待审核！'
                })
              }
            })
          }
        })
      } else {
        this.$refs['replyForm'].validate(valid => {
          if (valid) {
            AuthorComment({
              remId: this.activeRow.remId,
              authReplyContent: this.replyForm.replyContent
            }).then(res => {
              if (res && res.code === 200) {
                this.visible = false
                this.replyForm.replyContent = ''
                this.activeRow = null
                this.isAuthorReply = false
                this.queryCommentList()
              }
            })
          }
        })
      }
    },

    getDetail () {
      const { query: { id } } = this.$route
      if (!id) {
        this.$router.push('/search')
      }
      let params = {
        id: id,
        aId: this.isAuthor()
      }

      getDetail(params).then(res => {
        if (res && res.code === 200) {
          this.mxType = res.data.mxType
          this.imgList = res.data.imageList || []
          this.title = res.data.title
          this.priceType = res.data.priceType;
          this.price = res.data.price
          this.classifyIdList = res.data.classifyIdList
          this.assetsId = res.data.assetsId
          this.includeIdList = res.data.includeIdList
          this.isAuth = res.data.isAuth
          this.creatorAvatar = res.data.creatorAvatar
          this.creatorName = res.data.creatorName
          this.creatorId = res.data.creatorId
          this.surfaceNum = res.data.surfaceNum
          this.pointNum = res.data.pointNum
          this.getLabel(res.data.labelIdList || [])
          this.getClass(res.data.classifyIdList || [])
          this.getIndustry(res.data.industryIdList || [])
          this.softwareIdList = res.data.softwareIdList || []
          this.rendererIdList = res.data.rendererIdList || []
          this.copyright = res.data.copyright || ''
          this.remark = res.data.remark
          this.creatorId = res.data.creatorId
          this.creatorSex = res.data.creatorSex
          this.publishNum = res.data.publishNum;
          this.creatorId = res.data.creatorId;
          this.byDiscount = res.data.byDiscount
          this.hjDiscount = res.data.hjDiscount
          this.zsDiscount = res.data.zsDiscount
          this.memberType = res.data.memberType
        }
      })
    },

    /* 获取软件列表 */
    getSoftList () {
      mapListApi({ type: 2 }).then(res => {
        if (res.code === 200) {
          this.softList = res.data;
        }
      })
    },
    /* 获取渲染器列表 */
    getRenderList () {
      mapListApi({ type: 4 }).then(res => {
        if (res.code === 200) {
          this.renderList = res.data;
        }
      })
    },
    /* 获取包含 */
    getIncludeList () {
      mapListApi({ type: 5 }).then(res => {
        if (res.code === 200) {
          this.includeList = res.data;
        }
      })
    },
    /* 获取版权类型列表 */
    getCopyrightList () {
      mapListApi({ type: 6 }).then(res => {
        if (res.code === 200) {
          this.copyrightList = res.data;
        }
      })
    },
    /* 获取已选行业 */
    getIndustry (industryIdList) {
      const arr = industryIdList.map(item => industryIdApi(item))
      Promise.all(arr).then(res => {
        let arr = [];
        res.forEach(item => {
          if (item.code == 200) {
            arr.push({
              name: item.data.name,
              id: item.data.industryId
            });
          }
        });
        this.industryList = arr
      })
    },

    /* 获取标签 */
    getLabel (labelIdList) {

      const arr = labelIdList.map(item => getLabelById(item))
      Promise.all(arr).then(res => {
        let arr = [];
        res.forEach(item => {
          if (item.code == 200 && item.data.name) {
            arr.push({ name: item.data.name, id: item.data.labelId });
          }
        });
        this.labelList = arr

      })
    },
    /* 获取分类 */
    getClass (classifyIdList) {
      const arr = classifyIdList.map(item => classIdApi(item))
      Promise.all(arr).then(res => {
        let arr = [];
        res.forEach(item => {
          if (item.code == 200) {
            arr.push({
              name: item.data.categoryName,
              id: item.data.categoryId,
            });
          }
        });
        this.classifyList = arr
      })
    },
    authorBtnClick (row) {
      this.visible = true
      this.isAuthorReply = true
      this.activeRow = row
    },
    handleAddContent () {
      if (this.GET_USER_INFO && this.GET_USER_INFO.token) {
        this.visible = true
        this.isAuthorReply = false
      } else {
        this.$message({
          type: 'info',
          message: '请登录！'
        })
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      }
    },
    addCart () {
      const { query: { id } } = this.$route
      if (!this.GET_USER_INFO.token) {
        this.SET_CART_VISIBLE(true)
        return
      }
      getCart().then(res => {
        if (res && res.code === 200) {
          let list = res.data || []
          let isHas = false
          list.forEach(item => {
            if (item.assetsId === +id) {
              isHas = true
            }
          })
          if (isHas) {
            this.SET_CART_VISIBLE(true)
          } else {
            addCart({
              assetsId: id
            }).then(res => {
              if (res && res.code === 200) {
                this.SET_CART_VISIBLE(true)
              }
            })
          }
        }
      })
    },

    // 瀏覽器返回按鈕
    goBack () {
      sessionStorage.clear();
      window.history.back();
    },
    fetchData () {
      this.tableLoading = true;
      if (this.GET_USER_INFO && this.GET_USER_INFO.token) {
        queryWorkList(this.pageObj).then((res) => {
          this.tableList = res.data.list;
          this.total = res.data.total;
          this.tableLoading = false;
        });
      } else {

      }

    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let woTypeDesc;
          this.workTypes.forEach((i) => {
            if (this.form.woType === i.woTypeCode) {
              woTypeDesc = i.woTypeName;
            }
          });
          createWork({ ...this.form, status: 1, woTypeDesc }).then((res) => {
            if (res && res.code === 200) {
              this.dialogVisible = false;
              this.fetchData();
            }
          });
        }
      });
    },

  },
  watch: {
    '$route' (newval, oldval) {
      const { query: { id } } = newval
      const { query: { id: oldId } } = oldval
      if (id !== oldId) {
        this.getDetail()
        this.getSoftList()
        this.getRenderList()
        this.getCopyrightList()
        this.queryCommentList()
        this.isAuthor()
        this.getIncludeList()
      }
    }
  }
};
</script>

<style lang="less" scoped>
.__anthor {
  display: flex;

  .avatar {
    width: 60px;

    .a {
      border-radius: 50%;
      width: 50px;
      height: 50px;
      margin-left: 5px;
      background: #f5f5f5;
    }
  }

}

.home-box {
  min-width: 1000px;
  min-height: 100vh;
  background-color: #f7f7f7;
  margin-bottom: 30px;
}

.__remark {
  line-height: 30px;
  white-space: pre-wrap;
  font-size: 13px;
  color: rgb(128, 128, 128);
  word-wrap: break-word;
}

.banner {
  height: 650px;
  margin-top: 0px;
  width: 100%;
  background: linear-gradient(#9db3c3, #959791);
  position: relative;

  .title {
    height: 50px;
    background-color: #1c6f6e;


    .c {
      margin: 0 auto;
      display: flex;

      h1 {
        font-size: 20px;
        font-weight: bold;
        margin-left: 20px;
        padding: 0px 0px;
        min-height: 25px;
        max-width: 700px;
        color: #ffffff;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: 50px;
        flex: 1;
        position: absolute;
        left: 0;
        bottom: 0px;
      }

      .textprice {
        color: #808080;
        margin-right: 10px;
      }

      .mxtypetext,
      .typetext {
        display: inline-block;
      }

      .pricenum {
        margin-right: 10px;
      }

      .pricenum_1 {
        color: #808080;
        font-weight: normal;
        text-decoration: line-through;
        margin-right: 10px;
      }

      .dispricetxt,
      .textrebates {
        color: #E0B58C;
      }

      .dispricetxt {
        margin-right: 10px;
      }

      .vipFreeText {
        font-size: 15px;
        height: 30px;
        width: 8%;
        line-height: 30px;
        color: rgb(175, 151, 14);
        font-weight: bold;
        cursor: pointer;
        position: absolute;
        right: 24%;
        bottom: 10px;
        flex: 1;
      }

      .btn {
        background-color: #ff8135;
        font-size: 15px;
        width: 6%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        border-radius: 3px;
        cursor: pointer;
        position: absolute;
        right: 11%;
        bottom: 10px;
        flex: 1;
      }

      .price {
        font-size: 15px;
        height: 30px;
        line-height: 30px;
        color: #ff8135;
        font-weight: bold;
        cursor: pointer;
        position: absolute;
        right: 18%;
        bottom: 10px;
        flex: 1;
      }

      .price-type {
        font-size: 15px;
        height: 30px;
        line-height: 30px;
        color: #ff8135;
        font-weight: bold;
        cursor: pointer;
        position: absolute;
        right: 18%;
        bottom: 10px;
        flex: 1;
      }

      .price-type_1 {
        font-size: 15px;
        height: 30px;
        line-height: 30px;
        color: #ff8135;
        font-weight: bold;
        cursor: pointer;
        position: absolute;
        right: 18%;
        bottom: 10px;
        flex: 1;
      }
    }
  }
}

.__d {
  width: 1500px;
  margin: 0 auto;
  min-height: 100vh;

  .el-tag {
    background-color: rgb(255, 239, 239);
    display: inline-block;
    height: 28px;
    padding: 0 10px;
    line-height: 28px;
    font-size: 12px;
    color: grey;
    font-size: 12px;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    display: inline-block;
    background-color: #e5e5e5;
    border-radius: 4px;
    margin-right: 10px;
    line-height: 28px;
    border: none;
    margin-top: 10px;
    font-size: 12px;
  }

  .___d {
    width: 1500px;
    display: flex;
  }

  &::before {
    content: "";
    display: table;
    clear: both;
  }

  ;

  .___r {
    width: 382px;
    height: 999;
    margin-top: 15px;
  }

  .content {
    margin-right: 15px;
    margin-top: 15px;
    flex: 1;
    margin-bottom: 50px;

    .info {
      margin-bottom: 30px;
    }
  }

}

.c_time {
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  text-align: right;
  color: #808080;
}

.__r {
  line-height: 24px;
  color: #808080;
}

.comment_inner {
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 5px;
  position: relative;

  .authorBtn {
    position: absolute;
    right: 0;
    top: 5px;
    font-size: 12px;
    color: #FA5C5C;
    cursor: pointer;
  }
}

.__rcommet {
  margin-top: 20px;
  text-indent: 24px;
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 20px;

  pre {
    padding-left: 30px;
  }
}

::v-deep .el-divider {
  margin-bottom: 48px;

  .el-divider__text {
    background: #f7f7f7;
    font-size: 24px;
  }
}
</style>
<style lang="less" scoped>
.__d {
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #242424;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #242424 !important;
    border-color: #242424 !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #242424 !important;
  }

  .el-checkbox__inner:hover {
    border-color: #242424;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #242424 !important;
    color: #FFF;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #242424;
    color: #FFF;
  }
}

.officialText,
.copyrightText {
  color: #E0705A;
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
}

.descContent,
.descContent_1 {
  margin-top: 20px;
  font-size: 14px;
  color: #888;

  div {
    line-height: 20px;
  }
}

.copyrightText {
  margin-top: 20px;
}

.descContent_1 {
  box-sizing: border-box;
  padding-bottom: 26px;

  .txt {
    line-height: 40px;
  }
}

.helpInstructDia {
  color: #000;
  line-height: 30px;
}

.sureBtn {
  width: 80px;
  height: 40px;
  line-height: 40px;
  border: none;
  border-radius: 5px;
  text-align: center;
  background-color: rgb(238, 64, 64);
  color: #fff;
  position: absolute;
  left: 45%;
  bottom: 10px;
  cursor: pointer;
}
</style>
